import { Component, input, model, output, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { CatalogFilterMode } from '../models/catalog-scope.enum';
import { SCOPE_FILTER_OPTIONS } from './catalog-scope-constants';
import { UserRoles } from 'src/app/core/components/user-admin-page/user-model';

@Component({
  selector: 'app-scope-filter',
  template: `
  <div class="flex flex-col">
    <label for="scopeFilter">Scope</label>
    <p-select 
      inputId="scopeFilter" 
      [ngModel]="selectedFilter()" 
      [options]="scopeFilterOptions()"
      (onChange)="onFilterChange($event)" 
      [style]="{ 'min-width': '100px' }">
    </p-select>
  </div>
  `,
  standalone: true,
  imports: [FormsModule, Select]
})
export class ScopeFilterComponent {
  public selectedFilter = model<CatalogFilterMode>(CatalogFilterMode.AllItems);
  
  public userRoles = input<UserRoles>();
  
  public filterChange = output<void>();

  public scopeFilterOptions = signal([...SCOPE_FILTER_OPTIONS]);

  public onFilterChange(event: any): void {
    this.selectedFilter.set(event.value);
    this.filterChange.emit();
  }

}